import axios from 'axios';
import api from './api';
import { POOJARI_API } from '../utils/constants';

/**
 * ⚠️ SAARA PAISA PAISE MEIN AATA HAI aur PAISE MEIN JAATA HAI.
 *    50000 = ₹500
 *
 * Services bhejte waqt field ke naam ab:
 *    priceInPaise         (pehle: price)
 *    samagriPriceInPaise  (pehle: samagriPrice)
 *
 * ⚠️ Naam JAAN-BOOJH KE badle gaye. Purana frontend 500 bhejta
 * tha (matlab ₹500), aur naya backend usko 500 paise = ₹5 samajh
 * leta - 100 guna galti bina kisi error ke. Naam badalne se purana
 * caller turant fail karta hai.
 *
 * Form se rupees aate hain - toPaise() lagana ZAROORI hai
 * (utils/money.js).
 */

// Registration se pehle OTP bhejo
export const sendPoojariOtp = async (email, name) => {
	const response = await api.post(`${POOJARI_API}/send-otp`, {
		email,
		name,
	});
	return response.data;
};

// OTP verify karo
export const verifyPoojariOtp = async (email, otp) => {
	const response = await api.post(`${POOJARI_API}/verify-otp`, {
		email,
		otp,
	});
	return response.data;
};

// Register poojari
export const registerPoojari = async (poojariData) => {
	const response = await api.post(`${POOJARI_API}/register`, poojariData);
	return response.data;
};

// Login poojari
export const loginPoojari = async (credentials) => {
	const response = await api.post(`${POOJARI_API}/login`, credentials);
	return response.data;
};

// Get poojari by ID
// ⚠️ chargePerPooja aur services ke prices PAISE mein aate hain
export const getPoojariById = async (id) => {
	const response = await api.get(`${POOJARI_API}/${id}`);
	return response.data;
};

// Get all approved poojaris
export const getApprovedPoojaris = async () => {
	const response = await api.get(`${POOJARI_API}/approved`);
	return response.data;
};

// Get all available poojaris
export const getAvailablePoojaris = async () => {
	const response = await api.get(`${POOJARI_API}/available`);
	return response.data;
};

// Get poojaris by city
export const getPoojarisByCity = async (city) => {
	const response = await api.get(`${POOJARI_API}/city/${city}`);
	return response.data;
};

// Get poojaris by specialization
export const getPoojarisBySpecialization = async (specialization) => {
	const response = await api.get(
		`${POOJARI_API}/specialization/${specialization}`
	);
	return response.data;
};

// Search by city + specialization
export const searchPoojaris = async (city, specialization) => {
	const response = await api.get(
		`${POOJARI_API}/search?city=${city}&specialization=${specialization}`
	);
	return response.data;
};

// Get top rated poojaris
export const getTopRatedPoojaris = async () => {
	const response = await api.get(`${POOJARI_API}/top-rated`);
	return response.data;
};

// Pincode ke aas paas ke poojaris
export const getNearbyPoojaris = async (pincode) => {
	const response = await api.get(`${POOJARI_API}/nearby/${pincode}`);
	return response.data;
};

// Pincode + pooja type dono se
export const getNearbyPoojarisBySpecialization = async (
	pincode,
	specialization
) => {
	const response = await api.get(
		`${POOJARI_API}/nearby-search?pincode=${pincode}&specialization=${specialization}`
	);
	return response.data;
};

/**
 * Update poojari profile.
 *
 * ⚠️ poojariData.services mein har item aisa hona chahiye:
 *   {
 *     poojaType: "Ganesh Pooja",
 *     priceInPaise: 50000,          <- toPaise(500)
 *     durationMinutes: 60,
 *     samagriAvailable: true,
 *     samagriPriceInPaise: 30000    <- toPaise(300)
 *   }
 */
export const updatePoojari = async (id, poojariData) => {
	const response = await api.put(`${POOJARI_API}/update/${id}`, poojariData);
	return response.data;
};

// Toggle availability
export const toggleAvailability = async (id) => {
	const response = await api.put(
		`${POOJARI_API}/toggle-availability/${id}`,
		{}
	);
	return response.data;
};

// Get poojari by email
export const getPoojariByEmail = async (email) => {
	const response = await api.get(`${POOJARI_API}/email/${email}`);
	return response.data;
};

// ============================================================
// BANK DETAILS (B2)
//
// Razorpay Route ke liye zaroori - iske bina poojari ke bank
// mein paisa bhej hi nahi sakte.
//
// ⚠️ Registration pe ye NAHI maange jaate. Tab maange jaate hain
// jab poojari pehli booking accept karne jaata hai - tab tak wo
// invested hai aur bhar dega.
// ============================================================

/**
 * Poojari ke bank details laao.
 *
 * ⚠️ Account number aur PAN MASKED aate hain - poora kabhi nahi.
 *    bankAccountNumber: "****4521"
 *    pan: "ABCDE****F"
 *
 * @returns {
 *   hasBankDetails, accountHolderName, bankAccountNumber (masked),
 *   ifscCode, pan (masked), razorpayLinked, canAcceptBookings,
 *   message
 * }
 */
export const getBankDetails = async (poojariId) => {
	const response = await api.get(`${POOJARI_API}/bank-details/${poojariId}`);
	return response.data;
};

/**
 * Bank details save/update karo.
 *
 * ⚠️ accountHolderName PAN card ke naam se EXACTLY match hona
 * chahiye. Razorpay ke ~40% rejections isi mismatch se hote hain.
 * Form pe ye warning dikhani zaroori hai.
 *
 * ⚠️ Sirf poojari KHUD apne details badal sakta hai - backend
 * ownership check karta hai. Admin bhi nahi badal sakta.
 *
 * @param bankData {
 *   accountHolderName,
 *   bankAccountNumber,
 *   confirmAccountNumber,   <- typo check ke liye, dono match hone chahiye
 *   ifscCode,               <- backend UPPERCASE kar deta hai
 *   pan                     <- backend UPPERCASE kar deta hai
 * }
 */
export const updateBankDetails = async (poojariId, bankData) => {
	const response = await api.put(
		`${POOJARI_API}/bank-details/${poojariId}`,
		bankData
	);
	return response.data;
};

/**
 * Poojari logout - refresh token revoke karo.
 *
 * ⚠️ AuthContext ise use karta hai.
 */
export const logoutPoojari = async (refreshToken) => {
	const response = await api.post(`${POOJARI_API}/logout`, {
		refreshToken,
	});
	return response.data;
};

// ===== PASSWORD RESET =====
// ⚠️ Plain axios - api instance se NAHI. Uske interceptor mein
// 401 pe forceLogout() hai, aur password reset ke waqt banda
// logged in hai hi nahi.

// Step 1 - "password bhool gaya", email pe OTP bhejo
export const sendPoojariForgotPasswordOtp = async (email) => {
    const response = await axios.post(
        `${POOJARI_API}/forgot-password`, { email });
    return response.data;
};

// Step 2 - OTP + naya password ek saath
export const resetPoojariPassword = async (email, otp, newPassword) => {
    const response = await axios.post(
        `${POOJARI_API}/reset-password`, { email, otp, newPassword });
    return response.data;
};

/**
 * Nearby search - pincode + optional specialization.
 *
 * ⚠️ Home.js ise use karta hai.
 *
 * specialization diya ho to /nearby-search, warna /nearby.
 */
export const searchNearbyPoojaris = async (pincode, specialization) => {
	if (specialization) {
		return getNearbyPoojarisBySpecialization(pincode, specialization);
	}
	return getNearbyPoojaris(pincode);
};


// ============================================================
// POOJA TYPE PROPOSALS
//
// Poojari ko dropdown mein apni pooja na mile to wo nayi pooja ka
// proposal bhej sakta hai. Admin approve karega, phir wo naam
// sabke dropdown mein aa jaayega.
// ============================================================

/**
 * Nayi pooja ka proposal bhejo.
 *
 * ⚠️ poojariId NAHI bhejna — backend token se leta hai. Bhejne ki
 *    koshish ki to wo waise bhi nazarandaaz hoga.
 */
export const submitPoojaTypeProposal = async (proposedName) => {
    const response = await api.post(
        `${POOJARI_API}/pooja-types/proposals`, { proposedName });
    return response.data;
};

/**
 * Apne bheje hue proposals — naye pehle.
 *
 * ⚠️ Koi id parameter nahi — backend token se poojari pehchanta
 *    hai. Isliye doosre ke proposals maangne ka raasta hi nahi.
 */
export const getMyPoojaTypeProposals = async () => {
    const response = await api.get(
        `${POOJARI_API}/pooja-types/proposals/mine`);
    return response.data;
};